import React, { useContext } from 'react';
import { GoogleMap, MarkerF } from '@react-google-maps/api';
import { FormContext } from 'context/FormContext';

const MapAddressSelection = () => {
    const { formValues } = useContext(FormContext);

    const mapStyles = {
        width: '100%',
        height: '100%',
    };

    const containerStyles = {
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        width: '100%',
    };

    return (
        <div className="MapContainer full-height" style={containerStyles}>
            <GoogleMap
                mapContainerStyle={mapStyles}
                center={formValues.Address.LatLng || { lat: 50.14407031082436, lng: 8.579974394470517 }}
                zoom={20}
                onLoad={(map) => {
                    if (formValues.Address.LatLng) {
                        map.panTo(formValues.Address.LatLng);
                    }
                }}
                options={{
                    disableDefaultUI: true,
                    draggable: false,
                }}
            >
                {formValues.Address.LatLng && (
                    <MarkerF position={formValues.Address.LatLng} />
                )}
            </GoogleMap>
        </div>
    );
};

export default MapAddressSelection;
